export function normalizeSlateData(data: any): any {
  // Handle case where data is a plain string
  if (typeof data === 'string') {
    // Convert plain string to Slate format
    return [
      {
        type: 'paragraph',
        children: [{ text: data }],
      },
    ];
  }

  if (data.children) {
    return normalizeSlateData(data.children);
  }

  if (Array.isArray(data)) {
    return data.map((node: any) => {
      if (!node.type && Array.isArray(node.children)) {
        node.type = 'paragraph';
      }

      if (typeof node.text === 'string' && node.children) {
        return {
          type: node.type || 'paragraph',
          children: [{ text: node.text }].concat(normalizeSlateData(node.children)),
        };
      }

      if (node.children) {
        return {
          ...node,
          children: normalizeSlateData(node.children),
        };
      }

      return node;
    });
  }

  return [{ type: 'paragraph', children: [{ text: '' }] }];
}

export const extractMessageText = (messageContent: string): string => {
  try {
    const parsed = normalizeSlateData(JSON.parse(messageContent));

    const extractTextFromNodes = (nodes: any[]): string => {
      return nodes
        .map((node) => {
          if (typeof node.text === 'string') {
            return node.text;
          }
          if (Array.isArray(node.children)) {
            return extractTextFromNodes(node.children);
          }
          return '';
        })
        .join(' ');
    };

    if (Array.isArray(parsed)) {
      return extractTextFromNodes(parsed);
    }

    if (typeof parsed === 'string') {
      return parsed;
    }

    return messageContent;
  } catch (error) {
    console.error('Error parsing message:', error);
    return messageContent;
  }
};
